import LICENSE_TYPES from '@/enums/licenseTypes';
import USER_ROLES from '@/enums/userRoles';
import ROUTES from '../../enums/routes';

// eslint-disable-next-line no-unused-vars
export default function getClientNavigation(store) {
  const ePcrItems = [
    {
      icon: 'content_paste',
      title: 'Incidents',
      items: [
        {
          icon: 'mdi-clipboard-outline',
          title: 'Regular',
          route: ROUTES.INCIDENTS_REGULAR,
        },
        {
          icon: 'mdi-clipboard-text-outline',
          title: 'AP ToBeCompleted',
          route: ROUTES.INCIDENTS_AP_FORMS,
        },
        {
          icon: 'mdi-blood-bag',
          title: 'Blood Transfusion',
          route: ROUTES.INCIDENTS_BLOOD_TRANSFUSIONS,
          isAvailable() {
            return store.state.user.licenseTypeId === LICENSE_TYPES.PHYSICIAN
                || store.state.user.userTypeId === USER_ROLES.CLIENT_ADMIN;
          },
        },
        {
          icon: 'mdi-cloud-outline',
          title: 'Incident Cloud',
          route: ROUTES.INCIDENTS_CLOUD_DELETED,
        },
        {
          icon: 'mdi-format-list-bulleted',
          title: 'Log',
          route: ROUTES.INCIDENTS_LOG,
        },
        {
          icon: 'notification_important',
          title: 'Monitor/Alerts',
          route: ROUTES.INCIDENTS_MONITORS,
        },
        {
          icon: 'mdi-head-lightbulb-outline',
          title: 'QA/QI Insights',
          route: ROUTES.INSIGHTS,
        },
      ],
    },
    {
      icon: 'devices',
      title: 'Devices',
      route: ROUTES.DEVICES,
    },
    {
      icon: 'picture_as_pdf',
      title: 'Reference Materials',
      route: ROUTES.MATERIALS,
    },
  ];

  const navigationPart1 = [
    {
      icon: 'dashboard',
      title: 'Dashboard',
      route: ROUTES.DASHBOARD,
    },
    {
      icon: 'people',
      title: 'Users',
      route: ROUTES.USERS,
    },
    {
      icon: 'mdi-book-education-outline',
      title: 'CE Entry/Reports',
      route: ROUTES.CE_ENTRY,
      isAvailable() {
        return store.state.user && store.state.user.ceHoursEnabled;
      },
    },
  ];

  let navigationPart2 = [];
  if (store.state.siteInfo.nerisEnabled) {
    navigationPart2 = [
      {
        icon: 'mdi-car-emergency',
        title: 'NERIS',
        items: [
          {
            icon: 'mdi-alarm-light-outline',
            title: 'Incidents',
            route: ROUTES.NERIS_INCIDENTS,
          },
          {
            icon: 'mdi-hospital-box-outline',
            title: 'My Department',
            route: ROUTES.NERIS_ENTITY,
          },
          {
            icon: 'mdi-map-marker-radius-outline',
            title: 'Stations',
            route: ROUTES.NERIS_STATIONS,
          },
        ],
      },
      {
        icon: 'mdi-clipboard-pulse-outline',
        title: 'ePCR',
        items: ePcrItems,
      },
    ];
  } else {
    navigationPart2 = ePcrItems;
  }

  const navigationPart3 = [
    {
      icon: 'settings',
      title: 'Settings',
      route: ROUTES.PROFILE_SETTINGS,
    },
    {
      icon: 'build',
      title: 'Utilities',
      route: ROUTES.UTILITIES,
      divided: true,
      items: [
        {
          title: 'Reports/Incidents',
          icon: 'content_paste',
          items: [
            {
              icon: 'mdi-clipboard-search-outline',
              title: 'Incident System Search',
              route: ROUTES.INCIDENT_SYSTEM_SEARCH,
              description:
                  'Search incidents by entire system',
            },
            {
              icon: 'mdi-clipboard-text-clock',
              title: 'APOT Reconciliation',
              route: ROUTES.APOT_INCIDENTS,
              description: 'Ambulance Patient Offload Time incidents report.',
            },
          ],
        },
        {
          title: 'DHS/Billing',
          icon: 'mdi-bank-transfer',
          items: [
            {
              icon: 'folder_shared',
              title: 'Reconciliation',
              route: ROUTES.RECONCILIATION,
              description: 'Reconciliation.',
            },
            {
              icon: 'import_export',
              title: 'NEMSIS/DHS Export',
              route: ROUTES.DHS_EXPORT_UTILITY,
              description: 'Management of NEMSIS to DHS export.',
            },
            {
              icon: 'import_export',
              title: 'Billing Export',
              route: ROUTES.EXPORT_LOG_BILLING,
              description: 'Billing export data log.',
            },
            {
              icon: 'import_export',
              title: 'Unfiltered Export',
              route: ROUTES.EXPORT_LOG_UNFILTERED,
              description: 'Unfiltered export data log.',
              isAvailable() {
                return store.state.siteInfo.hasUnfilteredData;
              },
            },
          ],
        },
        {
          title: 'CAD',
          icon: 'mdi-car-emergency',
          items: [
            {
              icon: 'notification_important',
              title: 'CAD Monitoring',
              route: ROUTES.CAD_MONITORING,
              description: 'Status of CAD service.',
              isAvailable() {
                return store.state.siteInfo.cadMonitoringAllowed
                    && store.getters.ability.can('showCadMonitoring', 'navigation');
              },
            },
            {
              icon: 'horizontal_split',
              title: 'Recent CAD Data',
              route: ROUTES.LAST_IMPORTED_INCIDENTS,
              description: 'Review RAW data received from CAD service.',
            },
            {
              icon: 'mdi-table-arrow-right',
              title: 'NFIRS Export',
              route: ROUTES.NFIRS_EXPORT,
              description: 'NFIRS export service.',
            },
          ],
        },
        {
          title: '3rd Party Exports',
          icon: 'mdi-export',
          items: [
            {
              icon: 'import_export',
              title: 'OD MAP Exports',
              route: ROUTES.OD_MAP_EXPORTS,
              description: 'Export log of drugs suspected incidents.',
              isAvailable() {
                return store.state.siteInfo.odMapExportsAllowed;
              },
            },
          ],
        },
        {
          title: 'Miscellaneous',
          icon: 'mdi-tools',
          items: [
            {
              icon: 'flag',
              title: 'Flagged Users',
              route: ROUTES.FLAGGED_USERS,
              description: 'Review list of Flagged Users / Incidents.',
            },
            {
              icon: 'notes',
              title: 'Release Notes',
              route: ROUTES.RELEASE_NOTES,
              description:
                  'Provide information on the features and improvements in each release: iOS App, Template, Backend',
            },
          ],
        },
      ],
    },
  ];

  return [...navigationPart1, ...navigationPart2, ...navigationPart3];
}
